import env from '../config/env'
import Vue from 'vue'
import store from '../store'

function install (Vue) {
  Vue.env = Vue.prototype.env = env
  store.commit('config/setEnv', env)
}
Vue.use(install)
export default install
